<pxc-gradient class="absolute inset-0" />
<div class="border-t border-border-secondary"></div>
<div class="container relative z-10 flex py-8">
  <div class="w-full flex-1">
    <router-outlet data-testid="content" />
  </div>
  <router-outlet name="dialog" />
</div>
